import { h2, paragraph } from "@/styles/typography";
import styled from "styled-components";

const Container = styled.div<{ backgroundColor: string }>`
  padding: 70px 0 70px 20px;
  width: calc(100% + 140px);
  margin-left: -70px;
  min-height: 400px;
  background-color: ${(props) => props.backgroundColor};

  @media ${({ theme }) => theme.breakpoints.sm} {
    width: calc(100% + 32px);
    margin-left: -16px;
    padding: 50px 0px;
  }
`;

const GridContainer = styled.div<{ center: boolean }>`
  width: 100%;
  display: flex;
  justify-content: ${({ center }) => (center ? "center" : "flex-start")};
  @media ${({ theme }) => theme.breakpoints.md} {
    display: block;
  }
`;

const GridItem = styled.div`
  margin: 0 50px 0px 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 330px;

  @media ${({ theme }) => theme.breakpoints.md} {
    margin: 0 auto;
    max-width: 100%;
    padding: 0 16px;
  }
`;

const TitleWrapper = styled.div`
  padding: 0 50px;

  @media ${({ theme }) => theme.breakpoints.sm} {
    padding: 0 16px;
  }
`;

const Title = styled(h2)<{ backgroundColor: string }>`
  text-transform: uppercase;
  color: ${(props) =>
    props.backgroundColor !== "white"
      ? ({ theme }) => theme.textColors.secondary
      : ({ theme }) => theme.textColors.primary};
`;

const Line = styled.div<{ backgroundColor: string }>`
  border: 2px solid
    ${(props) =>
      props.backgroundColor !== "white"
        ? ({ theme }) => theme.textColors.secondary
        : ({ theme }) => theme.textColors.primary};
  width: 200px;
  height: 0px;
  margin: 30px 0 50px 0;

  @media ${({ theme }) => theme.breakpoints.sm} {
    margin: 24px 0 32px 0;
  }
`;

const ImageWrapper = styled.a`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  object-fit: contain;
  object-position: center;

  .gatsby-image {
    object-fit: cover;
    object-position: center;
  }
`;

const Image = styled.img`
  width: 80%;
`;

const TextWrapper = styled.div`
  padding-bottom: 30px;
  margin-top: 20px;
`;

const Paragraph = styled(paragraph)<{ backgroundColor: string }>`
  margin-top: 20px;
  color: ${(props) =>
    props.backgroundColor !== "white"
      ? ({ theme }) => theme.textColors.secondary
      : ({ theme }) => theme.textColors.primary};
`;

const S = {
  Container,
  GridContainer,
  GridItem,
  TitleWrapper,
  Title,
  Line,
  ImageWrapper,
  Image,
  TextWrapper,
  Paragraph,
};

export default S;
